import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=4d504157&scoped=true&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=4d504157&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d504157",
  null
  
)

component.options.__file = "DashboardChart.vue"
export default component.exports